import React from "react";
import { Card } from "react-bootstrap";
import PropTypes from "prop-types";
const CardWeb = ({url}) => {
    return (
        <Card className="shadow" style={{ width: '100%', height: '700px' }}>
            <Card.Header className="bg-dark text-white">Formulario de Pago</Card.Header>
            <Card.Body style={{ padding: 0 }}>
                <iframe
                    src= {url}
                    title="Sitio embebido"
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                ></iframe>
            </Card.Body>
        </Card>
    );
};
CardWeb.propTypes = {
    url: PropTypes.string.isRequired
}
export default CardWeb;
